<template>
  <div class="person">
    <div class="content">
      <div class="content_left">
        <!-- <el-upload
                  class="avatar-uploader"
                  :action="action"
                  ref="uploadFile"
                  :headers="header"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="person.customerIcon" :src="person.customerIcon" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload> -->
        <div class="avatar">
          <div class="img_box" v-if="person.customerIcon || pre">
            <img v-if="person.customerIcon" :src="person.customerIcon" alt="" />
            <img
              v-if="person.customerIcon == ''"
              :src="person.customerIcon"
              alt=""
            />
            <p><i class="el-icon-edit"></i>{{ $t("home.avatarUpload") }}</p>
            <input
              type="file"
              @change="onchangedNew"
              accept=".jpg,.png,.jpeg"
            />
          </div>
          <div class="upload" v-else>
            <i class="el-icon-plus"></i>
            <input
              type="file"
              @change="onchangedNew"
              accept=".jpg,.png,.jpeg"
            />
          </div>
        </div>
      </div>
      <div class="content_right flex_center">
        <div class="content_one">
          <div class="flex_center form">
            <p :style="styleWidth">
              <i class="must">*</i>{{ $t("home.userName") }}:
            </p>
            <el-tooltip
              class="item"
              effect="dark"
              :content="person.customerName"
              placement="bottom"
            >
              <span v-show="!showUser">{{ person.customerName }}</span>
            </el-tooltip>

            <input v-show="showUser" v-model="person.customerName" />
            <i @click="showUser = true" v-show="!showUser">{{
              $t("home.change")
            }}</i>
          </div>
          <div class="flex_center">
            <p :style="styleWidth">{{ $t("home.numberId") }}:</p>
            <span>{{ person.customerAccountNum }}</span>
          </div>
          <div class="flex_center">
            <p :style="styleWidth">{{ $t("home.country") }}:</p>
            <span>{{ person.country }}</span>
          </div>
          <div class="flex_center">
            <p :style="styleWidth">{{ $t("home.registrationTime") }}:</p>
            <span>{{ person.createTime }}</span>
            <!-- <span></span> -->
          </div>
        </div>
        <div class="content_one">
          <div class="flex_center form">
            <p :style="styleWidth">
              <i class="must">*</i>{{ $t("home.email") }}:
            </p>
            <el-tooltip
              class="item"
              effect="dark"
              :content="person.customerMail"
              placement="bottom"
            >
              <span v-show="!showEmail">{{ person.customerMail }}</span>
            </el-tooltip>
            <input v-show="showEmail" v-model="person.customerMail" />
            <i @click="showEmail = true" v-show="!showEmail">{{
              $t("home.change")
            }}</i>
          </div>
          <div class="flex_center form">
            <p :style="styleWidth">{{ $t("home.phone") }}:</p>

            <span v-show="!showPhone">{{ person.customerPhone }}</span>
            <input v-show="showPhone" v-model="person.customerPhone" />
            <i @click="showPhone = true" v-show="!showPhone">{{
              $t("home.change")
            }}</i>
          </div>
          <div class="flex_center form">
            <p :style="styleWidth">
              <i class="must">*</i>{{ $t("home.company") }}:
            </p>
            <el-tooltip
              class="item"
              effect="dark"
              :content="person.customerCompanyName"
              placement="bottom"
            >
              <span v-show="!showCompany">{{
                person.customerCompanyName
              }}</span>
            </el-tooltip>

            <input v-show="showCompany" v-model="person.customerCompanyName" />
            <i @click="showCompany = true" v-show="!showCompany">{{
              $t("home.change")
            }}</i>
          </div>
          <div class="flex_center form">
            <p :style="styleWidth">{{ $t("home.address") }}:</p>
            <i
              @click="showAdd = true"
              v-show="person.customerAddress == '' && !showAdd"
              >{{ $t("home.edit") }}</i
            >
            <el-tooltip
              class="item"
              effect="dark"
              :content="person.customerAddress"
              placement="bottom"
            >
              <span
                style="cursor: pointer"
                @click="showAdd = true"
                v-if="person.customerAddress != '' && !showAdd"
                >{{ person.customerAddress }}</span
              >
            </el-tooltip>

            <input v-if="showAdd" v-model="person.customerAddress" />
            <i
              v-show="person.customerAddress != '' && !showAdd"
              @click="showAdd = true"
              >{{ $t("home.change") }}</i
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      @close="closeChange"
      :title="$t('home.modifyPwd')"
      :visible.sync="showChange"
    >
      <div>
        <el-form
          :model="modifyForm"
          :rules="modifyRules"
          ref="modifyForm"
          :label-width="labelWidth"
        >
          <!-- <el-form-item prop="number" :label="">
                    <el-input type="text"  :placeholder="$t('home.number')" v-model="modifyForm.number"></el-input>
                  </el-form-item > -->
          <el-form-item prop="loginPwd" :label="$t('home.oldPwd') + ':'">
            <el-input
              type="password"
              v-model="modifyForm.loginPwd"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="newPwd" :label="$t('home.enterNew') + ':'">
            <el-input
              show-password
              type="password"
              :placeholder="'(' + $t('home.limit') + ')'"
              v-model="modifyForm.newPwd"
            ></el-input>
            <p class="tips">{{ $t("request.fotmat") }}</p>
          </el-form-item>
          <el-form-item prop="againNewPwd" :label="$t('home.reEnterPwd') + ':'">
            <el-input
              show-password
              type="password"
              :placeholder="'(' + $t('home.limit') + ')'"
              v-model="modifyForm.againNewPwd"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitPwd('modifyForm')">{{
          $t("seek.confirm")
        }}</el-button>
        <el-button @click="showChange = false">{{
          $t("seek.cancel")
        }}</el-button>
      </div>
    </el-dialog>
    <div class="button flex_default_center">
      <el-button
        type="primary"
        v-show="isNew"
        :disabled="isNew"
        icon="el-icon-loading"
        >{{ $t("home.save") }}</el-button
      >
      <el-button type="primary" v-show="!isNew" @click="handleUpdate">{{
        $t("home.save")
      }}</el-button>
      <el-button type="primary" @click="toModify">{{
        $t("home.changePwd")
      }}</el-button>
    </div>
    <el-dialog
      width="800px"
      :title="$t('home.uploadTitle')"
      :visible.sync="dialogCut"
    >
      <div>
        <cutimg
          :fileName="picName"
          :fixedNum="[1, 1]"
          :cutWidth="200"
          :cutHeight="200"
          :fixed="true"
          @cancelCut="cancelCut"
          @confirmCut="confirmCut"
          :optionImg="imageUrl"
          :width="300"
          :height="300"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import cutimg from "@/components/cutimg";
import md5 from "js-md5";
import { baseURL2 } from "@/util/url";
import {
  updateCenter,
  getCenterInfo,
  modifyPwd,
  updateAvatar,
} from "@/api/api";
import { getSession } from "@/util/localStor";
var validatePass = (rule, value, callback) => {
  if (value === "") {
    let pwd = this.$t("home.pwd");
    callback(new Error(pwd));
  } else {
    if (this.modifyForm.againNewPwd !== "") {
      this.$refs.modifyForm.validateField("againNewPwd");
    }
    callback();
  }
};
var validatePass2 = (rule, value, callback) => {
  if (value === "") {
    let again = this.$t("home.againPwd");
    callback(new Error(again));
  } else if (value !== this.modifyForm.newPwd) {
    let error = this.$t("home.inconsistent");
    callback(new Error(error));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      isNew: false,
      originFile: "",
      picName: "",
      pre: "",
      isCacelCut: false,
      optionImg: "",
      dialogCut: false,
      showChange: false,
      // action:'/ht/manage/customer/upload/for/customer', //开发
      action: baseURL2 + "manage/customer/upload/for/customer",
      // action:'http://43.157.63.49:8187/manage/customer/upload/for/customer',
      imageUrl: "",
      showUser: false,
      showEmail: false,
      showPhone: false,
      showCompany: false,
      showAdd: false,
      person: {},
      header: {
        satoken: sessionStorage.getItem("satoken"),
      },
      nationList: [],
      country: "",
      avatar: "",
      modifyForm: {
        number: "",
        loginPwd: "",
        newPwd: "",
        againNewPwd: "",
      },
    };
  },
  components: { cutimg },
  computed: {
    modifyRules() {
      return {
        loginPwd: [
          {
            required: true,
            message: this.$t("home.oldNotEmpty"),
            trigger: "blur",
          },
          { min: 6, max: 12, message: this.$t("home.length"), trigger: "blur" },
        ],
        newPwd: [
          {
            required: true,
            message: this.$t("home.newNotEmpty"),
            trigger: "blur",
          },
          { min: 6, max: 12, message: this.$t("home.length"), trigger: "blur" },
          // { validator: validatePass, trigger: 'blur' }
        ],
        againNewPwd: [
          {
            required: true,
            message: this.$t("home.reNotEmpty"),
            trigger: "blur",
          },
          { min: 6, max: 12, message: this.$t("home.length"), trigger: "blur" },
          // { validator: validatePass2, trigger: 'blur' }
        ],
      };
    },
    styleWidth() {
      const widthMap = {
        zh: "width: 80px",
        en: "width: 145px",
        ru: "width: 185px",
        fa: "width: 135px",
        vi: "width: 175px",
        es: "width: 215px",
      };
      return widthMap[this.$i18n.locale] || "width: 150px";
    },
    labelWidth() {
      const widthMap = {
        zh: "100px",
        en: "145px",
        ru: "180px",
        fa: "120px",
        vi: "150px",
        es: "175px",
      };
      return widthMap[this.$i18n.locale] || "150px";
    },
  },
  mounted() {
    this.getPerson();
    // this.person = JSON.parse(sessionStorage.getItem('person'))
    this.nationList = Object.values(getSession("nationList"));
    //
  },
  methods: {
    onchangedNew(e) {
      let file = e.target.files[0];
      let formdata = new FormData();
      formdata.append("file", e.target.files[0]);
      // this.picName = file.name
      if (file.name.indexOf("svg")) {
        this.picName = file.name.replace(/.svg/, ".png");
      } else {
        this.picName = file.name;
      }
      this.originFile = file;
      let filemaxsize = 1024 * 2; //2M
      var size = file.size / 1024;
      if (size > filemaxsize) {
        this.$DonMessage.warning("附件大小不能大于" + filemaxsize / 1024 + "M！");
        return false;
      }
      if (size <= 0) {
        this.$DonMessage.warning("附件大小不能为0M！");
        return false;
      }
      let img = new FileReader();
      // img.readAsDataURL(file);
      // console.log("img:",img)
      img.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }

        this.imageUrl = data;
        this.dialogCut = true;
      };
      if (file.type == "image/svg+xml") {
        img.readAsDataURL(file);
      } else {
        img.readAsArrayBuffer(file);
      }
      e.target.value = "";
    },
    async uploadAvatar(data) {
      const res = await updateAvatar(data);
      if (res.status == 0) {
        // this.isNew = false
        this.person.customerIcon = encodeURI(res.data);
        this.isNew = false;
      }
    },
    cancelCut() {
      this.isCacelCut = true;
      this.dialogCut = false;
      if (this.pre == "" && this.existPic == "") {
      } else {
        this.pre = "";
      }
      let formdata = new FormData();
      formdata.append("file", this.originFile);
      this.uploadAvatar(formdata);
      // this.existPic = this.optionImg
    },
    confirmCut(data, preview) {
      this.isNew = true;
      this.dialogCut = false;
      this.pre = preview;
      this.uploadAvatar(data);
      // console.log(data)
    },
    closeChange() {
      this.resetForm("modifyForm");
    },
    // 重置
    resetForm(formName) {
      // const formName = 'newForm'
      this.$refs[formName].resetFields();
      this.$refs[formName].clearValidate();
    },
    // 修改密码
    async handleModify() {
      let query = {
        customerAccountNum: this.person.customerAccountNum,
        oldPassword: md5(this.modifyForm.loginPwd),
        newPassword: this.modifyForm.newPwd,
      };
      const result = await modifyPwd(query);

      if (result.status == 0) {
        this.$DonMessage.success(this.$t("home.saveSuccess"));
        this.resetForm("modifyForm");
        this.showChange = false;
        //   this.translateValue = 0
        this.$store.state.isLoading = false;
      } else {
        this.$DonMessage.warning(result.message);
        this.$store.state.isLoading = false;
      }
    },
    submitPwd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.modifyForm.newPwd != this.modifyForm.againNewPwd) {
            this.$DonMessage.warning(this.$t("home.inconsistent"));
            return;
          } else {
            this.$store.state.isLoading = true;
            this.handleModify();
          }
        } else {
          return false;
        }
      });
    },
    toModify() {
      this.showChange = true;
      // this.$router.push({name:'login',params:{isChange:true,from:'/center'}})
    },
    async getPerson() {
      const res = await getCenterInfo();
      if (res.status == 0) {
        this.person = res.data;
        this.getNation();
      }
      //  console.log(res)
    },
    // 获取国家
    getNation() {
      if (this.nationList) {
        let country = this.nationList.filter((item) => {
          return item.id == this.person.customerCountry;
        });
        if (this.$i18n.locale == "zh") {
          this.person.country = country[0].name;
        } else {
          this.person.country = country[0].enName;
        }
        // console.log(country)
      }
    },
    // 提交更新
    async handleUpdate() {
      this.$store.state.isLoading = true;
      let query = {
        data: {
          ...this.person,
        },
      };
      const res = await updateCenter(query);
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("home.saveSuccess"))
        this.showAdd =
          this.showCompany =
          this.showUser =
          this.showEmail =
          this.showPhone =
            false;
        // console.log(res)
      } else {
        this.$DonMessage.success(res.message);
      }
      this.$store.state.isLoading = false;
    },
    handleAvatarSuccess(res, file) {
      //   this.imageUrl = URL.createObjectURL(file.raw);
      if (res.status == 0) {
        this.person.customerIcon = res.data;
      } else {
        this.$DonMessage.warning(res.message);

        let uid = file.uid; // 关键作用代码，去除文件列表失败文件
        let idx = this.$refs.uploadFile.uploadFiles.findIndex(
          (item) => item.uid === uid
        );
        this.$refs.uploadFile.uploadFiles.splice(idx, 1);
      }
      //   console.log(res,'--------------avatar----------------')
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$DonMessage.warning(this.$t("home.avatarFormat"));
      }
      if (!isLt2M) {
        this.$DonMessage.warning(this.$t("home.img2M"));
      }
      return isJPG && isLt2M;
    },
  },
};
</script>
<style lang="scss" scoped>
.content_left {
  margin-bottom: 30px;
  padding-left: 20px;
  .avatar-uploader ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border-radius: 10px;
  }

  .avatar-uploader ::v-deep .el-upload:hover {
    border-color: var(--theme-color);
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 160px;
    height: 160px;
    line-height: 160px;
    text-align: center;
  }
  .avatar {
    width: 160px;
    height: 160px;
    display: block;
    border-radius: 10px;
  }
}
.content_right {
  .content_one {
    margin-left: 20px;
    line-height: 32px;
    .flex_center {
      margin: 8px 0;
    }
    p {
      text-align: right;
      margin-right: 6px;
    }
    span {
      width: 260px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }

    i {
      color: var(--theme-color);
      cursor: pointer;
      margin-left: 10px;
      font-style: normal;
      font-size: 14px;
    }

    input {
      outline: none;
      border: 1px solid var(--border-color);
      width: 260px;
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
      color: #333;
      font-size: 15px;
      border-radius: 4px;
      transition: 0.25s;
    }
    input:hover {
      border: 1px solid var(--theme-color);
    }
    .must {
      color: red;
      margin: 0 2px;
      font-size: 14px;
    }
  }
}
.button {
  width: 100%;
  margin-top: 50px;
}
.tips {
  font-size: 12px;
  color: red;
  letter-spacing: 0px;
  line-height: 1.5;
  text-decoration: none;
}
.avatar {
  margin: 10px 0;
  .img_box {
    width: 160px;
    height: 160px;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      left: 0;
      top: 0;
    }
    p {
      display: none;
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      z-index: 3;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .img_box:hover {
    text-align: center;

    img {
      // z-index: -1;
    }
    p {
      cursor: pointer;
      height: 160px;
      background: rgba($color: #000000, $alpha: 0.4);
      width: 160px;
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      line-height: 160px;
      z-index: 2;
      color: #fff;
      font-size: 14px;
      i {
        color: #fff;
        font-size: 16px;
      }
    }
  }
  .upload {
    width: 100px;
    height: 100px;
    border-radius: 20px;
    background: #eee;
    overflow: hidden;
    text-align: center;
    position: relative;
    cursor: pointer;
    i {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 26px;
      color: #909399;
      cursor: pointer;
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }
}
</style>
